export default function Footer() {
  return (
    <footer className="border-t border-gray-200 bg-gray-50/80 py-8 sm:py-10 md:py-12">
      <div className="container mx-auto max-w-6xl px-4 sm:px-6">
        <p className="text-center text-sm sm:text-base text-gray-600">
          © 2025 PsyManage. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}
